(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').directive('apVerticalSeparator', [
        apVerticalSeparator
    ]);

    function apVerticalSeparator() {
        return {
            restrict: 'A',
            link: link,
        };

        function link(scope, elem, attrs) {
            var element = elem;
            var parent = elem.parent()[0];
            var target = document.getElementById(attrs.apVerticalSeparator);
            if (target) {
                parent = target;
            }

            function updateMaxHeight() {
                var reservedSpace = 0;

                if (element && element.length > 0) {
                    var paddingTopStr = element.css('padding-top');
                    var paddingBottomStr = element.css('padding-bottom');
                    var paddingTop = parseInt(paddingTopStr);
                    var paddingBottom = parseInt(paddingBottomStr);
                    if (paddingTop && paddingBottom) {
                        reservedSpace = paddingTop + paddingBottom;
                    }
                }

                var target = $(parent).height() - reservedSpace;

                element.css('max-height', target + 'px');
                element.css('height', target + 'px');
            }

            updateMaxHeight();

            var windowSelector = $(window);
            windowSelector.on('resize', updateMaxHeight);
            var observer = new MutationObserver(updateMaxHeight);

            observer.observe(parent, {attributes: true, subtree: true, attributeFilter: ['class']});

            scope.$on('$destroy', function(){
                windowSelector.off('resize', updateMaxHeight);
                observer.disconnect();
            });
        }
    }
})(angular);